import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import GuaziHeader from '@/components/feature/GuaziHeader';
import GuaziFooter from '@/components/feature/GuaziFooter';
import GuaziHero from '@/pages/home/guazi-components/GuaziHero';
import GuaziMascotBand from '@/pages/home/guazi-components/GuaziMascotBand';
import GuaziFeatures from '@/pages/home/guazi-components/GuaziFeatures';
import GuaziScreenshots from '@/pages/home/guazi-components/GuaziScreenshots';
import GuaziAdvantages from '@/pages/home/guazi-components/GuaziAdvantages';
import GuaziFaq from '@/pages/home/guazi-components/GuaziFaq';
import { guaziScrollToSection } from '@/hooks/guaziUseSectionNav';
import { useGuaziSeo } from '@/hooks/guaziUseSeo';

export default function Home() {
  const location = useLocation();

  useGuaziSeo({
    title: '瓜子影视 - 海量高清影视随时看',
    keywords: '瓜子影视',
    description: '瓜子影视聚合热门电影、电视剧、综艺、动漫、短剧等海量资源，高清流畅播放，更新及时，支持手机TV多端便捷观看。随时随地追剧看电影，精彩不停，尽在瓜子影视。',
    canonical: 'https://www.guaziyingshi.net/',
  });

  useEffect(() => {
    const state = location.state as { guaziScrollTo?: string } | null;
    const targetId = (state && state.guaziScrollTo) || location.hash.replace('#', '');
    if (targetId) {
      window.setTimeout(() => guaziScrollToSection(targetId), 60);
    }
  }, [location.state, location.hash]);

  return (
    <div className="w-full min-h-screen bg-background-50">
      <GuaziHeader />
      <main>
        <GuaziHero />
        <GuaziMascotBand />
        <GuaziFeatures />
        <GuaziScreenshots />
        <GuaziAdvantages />
        <GuaziFaq />
      </main>
      <GuaziFooter />
    </div>
  );
}